import * as React from 'react';
import { ReactElement, ReactNode } from 'react';
import { InputGroup } from '../../edit/components/layout/InputGroup';
import { Actions, MultiInputControls } from '../../components/form/MultiInput/MultiInputControls';
import Label from '../../components/Label';
import { getHelp } from '../../../util/intl.utils';
import { IntlShape, useIntl } from 'react-intl';
import { DatePeriod } from '../../../api/core';
import { Calendar } from 'primereact/calendar';
import moment from 'moment';

interface Props {
  label: string;
  datePeriods: DatePeriod[];
  onChange: (datePeriods: DatePeriod[]) => void;
}

export const FilterByCreated = (props: Props): ReactNode => {
  const intl: IntlShape = useIntl();
  return (
    <div className={'flex flex-column gap-2'}>
      <h4>
        <Label
          label={intl.formatMessage({id: `${props.label}.label`})}
          help={getHelp(intl, `${props.label}.help`)}
        />
      </h4>
      <MultiInputControls<DatePeriod>
        canEdit={false}
        min={1}
        max={1}
        addNew={(rows: DatePeriod[]): number => rows.push({start: null, end: null})}
        renderLines={(datePeriod: DatePeriod, onPeriodChange: (datePeriods: DatePeriod) => void, actions: Actions, idx: number): ReactElement => {
          return <InputGroup>
            <Calendar
              id={`yearFrom_${idx}`}
              value={datePeriod.start ? [datePeriod.start, datePeriod.end] : []}
              selectionMode={'range'}
              onChange={(event): void => {
                const start: Date = event.value?.length > 0 && event.value[0] ? moment(event.value[0]).utcOffset(0, true).toDate() : null;
                const end: Date = event.value?.length > 1 && event.value[1] ? moment(event.value[1]).utcOffset(0, true).toDate() : null;
                onPeriodChange({start, end});
              }}
              hideOnRangeSelection={true}
              locale={intl.locale}
              showButtonBar={true}

            />
          </InputGroup>;
        }}
        lines={props.datePeriods}
        onChange={(periods: DatePeriod[]): void => props.onChange(
          periods.filter((period: DatePeriod): boolean =>
            (period.start !== null && period.start !== undefined) || (period.end !== null && period.end !== undefined),
          ),
        )}
      />
    </div>
  );
};
